<template>
  <div v-if="uploadVideoInfo || uploadingSubTitle === UploadingState.Complete" id="container">
    <v-speed-dial
      v-model="fab"
      :bottom="true"
      :right="true"
      direction="left"
      fixed
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn @click="destroyView" style="width: 60px; height: 60px" v-model="fab" color="transparent" dark fab>
          <v-icon v-if="fab">
            {{ uploadingSubTitle === UploadingState.Complete ? 'mdi-close' : 'mdi-chevron-left' }}
          </v-icon>
          <v-progress-circular v-else fab :rotate="-90" :size="50" :width="5" :value="progressValue" color="#25c685">
            {{ progressValue }}
          </v-progress-circular>
        </v-btn>
      </template>

      <v-card
        align-center
        class="container-card-progress mb-10 px-2 py-1"
        style="margin-bottom: 40px; padding-left: 8px; padding-right: 8px; padding-top: 4px; padding-bottom: 4px"
        color="#31434f"
        width="400"
        elevation="10"
        no-gutters
        justify="center"
        align="start"
      >
        <v-row no-gutters class="pa-4 pl-3" style="padding: 16px; padding-left: 12px">
          <v-col cols="auto">
            <v-progress-circular fab :rotate="-90" :size="50" :width="5" :value="progressValue" color="#25c685">
              {{ progressValue }}
            </v-progress-circular>
          </v-col>
          <v-col>
            <v-row no-gutters class="px-3" style="padding-left: 12px; padding-right: 12px">
              <v-col cols="12">
                <span class="upload-title">
                  {{
                    isRetry
                      ? $t('failedUploadTitle')
                      : uploadingSubTitle !== UploadingState.Complete
                      ? $t('progressUploadingTitle')
                      : $t('progressCompleteTitle')
                  }}
                </span>
              </v-col>
              <v-col cols="12">
                <span class="upload-sub-title">
                  {{ isRetry ? $t('failedUploadSubTitle') : uploadingSubTitle }}
                </span>
              </v-col>
              <v-col v-if="isRetry" class="container-retry" cols="12">
                <v-btn color="#ff575f" width="100" style="margin-right: 24px" @click="cancel">
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn color="#27cd8b" width="100" @click="retry">
                  {{ $t('retry') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-row
            v-if="uploadingSubTitle === UploadingState.Complete"
            class="mt-4 mr-4"
            no-gutters
            style="position: absolute; top: 0; right: 0; margin-top: 16px; margin-right: 16px"
          >
            <v-icon @click="destroyView" size="18" color="#ffffff" style="cursor: pointer">mdi-close</v-icon>
          </v-row>
        </v-row>
      </v-card>
    </v-speed-dial>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Worker from 'worker-loader!@/worker/worker'

const failTypeThumbnail = 'thumbnail'
const failTypeClip = 'clip'

const UploadingState = Object.freeze({
  Preparing: 'Preparing ...',
  Thumbnail: 'Uploading thumbnail ...',
  Transcript: 'Uploading transcript ...',
  Clip: 'Uploading clip ...',
  Complete: 'Click x to close',
})

export default {
  name: 'UploadProgress',
  data() {
    return {
      UploadingState,
      progressValue: 0,
      uploadingSubTitle: UploadingState.Preparing,
      failedType: [],
      isRetry: false,
      path: 'https://file.tape.ooo/clip/',
      result: null,
      worker: null,

      direction: 'left',
      fab: true,
      hover: true,
      transition: 'slide-x-reverse-transition',
      isClipUploadLoading: false,
      FREE_USER_TRANSCRITION: true,
    }
  },
  computed: {
    ...mapGetters(['currentMt', 'currentClip', 'sectionIndex', 'uploadVideoInfo', 'isQuickRecord', 'wsClipCnt']),
    isIncludeThumbnail() {
      return this.failedType.includes(failTypeThumbnail)
    },
    isIncludeClip() {
      return this.failedType.includes(failTypeClip)
    },
    stId() {
      let stId = ''
      if (this.currentMt && this.sectionIndex && this.currentMt.sectionInfo && this.currentMt.sectionInfo.length > 0)
        stId = this.currentMt.sectionInfo[this.sectionIndex].stId

      return stId
    },
    isDisabledTranscript() {
      /**
       * ws plan 이 free 이거나 audioBlob 이 잘못 되었거나
       * free user 사용여부를 해제한 경우에 transcript 는 사용 불가
       */
      return (
        (!this.wsClipCnt || !this.wsClipCnt['planType'] || this.wsClipCnt['planType'] === 'Free') &&
        (!this.uploadVideoInfo ||
          !this.uploadVideoInfo['audioBlobs'] ||
          this.uploadVideoInfo['audioBlobs'].length <= 0) &&
        !this.FREE_USER_TRANSCRITION
      )
    },
  },
  created() {
    window.onbeforeunload = function (e) {
      if (this.isClipUploadLoading) {
        // Cancel the event and
        // show alert that the unsaved
        // changes would be lost
        e.preventDefault()
        e.returnValue = ''
      }
    }.bind(this)
  },
  mounted() {
    this.setUploadWorker()
  },
  updated() {
    localStorage.setItem('stId', this.stId)
  },
  methods: {
    setUploadWorker() {
      // 미팅 상세페이지 에서만 작동
      if (window.Worker) {
        this.worker = new Worker()
        let ctx = this
        this.worker.onmessage = (event) => {
          if (event && event['data'] && event['data'] !== '') {
            let data = event['data']
            let result = data['result']

            // thumbnaul 이벤트일 경우
            if (data['type'] === 'thumbnail') {
              switch (data['status']) {
                case 'uploading':
                  ctx.progressValue = data['progress']
                  break
                case 'done':
                  // 실패일 경우
                  if (!result || (result && result.$metadata.httpStatusCode !== 200)) {
                    ctx.failedType.push(failTypeThumbnail)
                    ctx.failedType = Array.from(new Set(ctx.failedType)).filter((item) => item !== '')
                  } else if (ctx.failedType && ctx.failedType !== '' && ctx.failedType.includes(failTypeThumbnail)) {
                    ctx.failedType.splice(ctx.failedType.indexOf(failTypeThumbnail), 1)
                  }

                  if ((data['isFirstTry'] || ctx.isIncludeClip) && !(ctx.textClip && ctx.textClip !== null)) {
                    // transcript 를 사용하지 않는다면 clip upload 호출
                    if (ctx.isDisabledTranscript) ctx.setClipUpload()
                    // transcript 를 사용할 경우 transcript upload 후 clip upload 호출
                    else ctx.setAudioTranscriptUpload()
                  } else if (ctx.failedType && ctx.failedType !== null && ctx.failedType.length > 0) {
                    ctx.isRetry = true
                  } else {
                    ctx.uploadFinish()
                  }
                  break
                default:
                  break
              }
            }
            // STT Audio File 업로드인 경우
            else if (data['type'] === 'transcript') {
              switch (data['status']) {
                case 'uploading':
                  ctx.progressValue = data['progress']
                  break
                case 'done':
                  // 실패일 경우
                  // if (!result || (result && result.$metadata.httpStatusCode !== 200)) {
                  //   ctx.failedType.push(failTypeClip)
                  //   ctx.failedType = Array.from(new Set(ctx.failedType)).filter((item) => item !== '')
                  // } else if (ctx.failedType && ctx.failedType !== '' && ctx.failedType.includes(failTypeClip)) {
                  //   ctx.failedType.splice(ctx.failedType.indexOf(failTypeClip), 1)
                  // }

                  // if (ctx.failedType && ctx.failedType !== '' && ctx.failedType.length > 0) {
                  //   ctx.isRetry = true
                  // } else {
                  ctx.setClipUpload()
                  // }
                  break

                default:
                  break
              }
            }
            // 클립 업로드일 경우
            else if (data['type'] === 'clip') {
              switch (data['status']) {
                case 'uploading':
                  ctx.progressValue = data['progress']
                  break
                case 'done':
                  // 실패일 경우
                  if (!result || (result && result.$metadata.httpStatusCode !== 200)) {
                    ctx.failedType.push(failTypeClip)
                    ctx.failedType = Array.from(new Set(ctx.failedType)).filter((item) => item !== '')
                  } else if (ctx.failedType && ctx.failedType !== '' && ctx.failedType.includes(failTypeClip)) {
                    ctx.failedType.splice(ctx.failedType.indexOf(failTypeClip), 1)
                  }

                  if (ctx.failedType && ctx.failedType !== '' && ctx.failedType.length > 0) {
                    ctx.isRetry = true
                  } else {
                    ctx.uploadFinish()
                  }
                  break

                default:
                  break
              }
            }
          }
        }
      }
    },
    // Thumbnail 업로드
    async setThumbnailUpload(isFirstTry) {
      try {
        if (
          (isFirstTry || this.isIncludeThumbnail) &&
          this.uploadVideoInfo['clip']['clipType'] &&
          this.uploadVideoInfo['clip']['clipType'] !== 'audio' &&
          this.uploadVideoInfo['thumbnail']
        ) {
          this.uploadingSubTitle = UploadingState.Thumbnail

          // background service 를 추가해줌
          if (this.worker) {
            this.worker.postMessage({
              type: 'thumbnail',
              thumbnail: this.uploadVideoInfo['thumbnail'],
              wsId: this.uploadVideoInfo['wsId'],
              clipId: this.uploadVideoInfo['clip']['clipId'],
              isFirstTry: isFirstTry,
            })
          }
        } else if (this.uploadVideoInfo['clip']['clipType'] === 'audio') {
          // transcript 를 사용하지 않는다면 clip upload 호출
          if (this.isDisabledTranscript) this.setClipUpload()
          // transcript 를 사용할 경우 transcript upload 후 clip upload 호출
          else this.setAudioTranscriptUpload()
        }
      } catch (e) {
        console.log('thumbnail upload failed  : ', e)
      }
    },
    // STT 를 위한 음성 녹화 파일을 업로드한다.
    async setAudioTranscriptUpload() {
      try {
        this.uploadingSubTitle = UploadingState.Transcript

        if (this.worker) {
          this.worker.postMessage({
            type: 'transcript',
            audioBlobs: this.uploadVideoInfo['audioBlobs'],
            wsId: this.uploadVideoInfo['wsId'],
            clipId: this.uploadVideoInfo['clip']['clipId'],
          })
        }
      } catch (e) {
        console.log('transcript failed  : ', e)
      }
    },
    // 영상 업로드
    async setClipUpload() {
      try {
        this.uploadingSubTitle = UploadingState.Clip
        this.uploadVideoInfo['clip']['clipType']

        // 기존 이곳에서 업로드하는걸 제외하고, 이곳에서 background service 를 추가해줌
        if (this.worker) {
          this.worker.postMessage({
            type: 'clip',
            blob: this.uploadVideoInfo['blob'],
            wsId: this.uploadVideoInfo['wsId'],
            clipId: this.uploadVideoInfo['clip']['clipId'],
            isDisabledTranscript: this.isDisabledTranscript,
          })
        }
      } catch (e) {
        console.log('clip upload failed  : ', e)
      }
    },
    retry() {
      this.isRetry = false
      this.setThumbnailUpload(false)
    },
    uploadFinish() {
      this.uploadingSubTitle = UploadingState.Complete
      this.$store.dispatch('setUploadVideoInfo', null)
      // 미팅 내부에서 quick record 를 할 때 페이지를 새로고침 해준다.
      if (this.currentMt && this.currentMt['mtId'] !== this.$route.params['mtId']) {
        location.reload()
      }
      this.isClipUploadLoading = false
      this.$store.dispatch('setIsQuickRecord', false)
    },
    destroyView() {
      if (this.uploadingSubTitle === UploadingState.Complete) {
        this.uploadingSubTitle = UploadingState.Preparing
        this.progressValue = 0
        this.fab = true
        this.hover = true
      }
    },
  },
  beforeDestroy() {
    if (this.worker) {
      this.worker.terminate()
      this.worker = null
    }
  },
  watch: {
    uploadVideoInfo: {
      // immediate: true,
      // deep: true,
      handler(value) {
        if (value && value['clip'] && value['blob']) {
          if (
            this.uploadingSubTitle === UploadingState.Preparing ||
            this.uploadingSubTitle === UploadingState.Complete
          ) {
            // 시작 전 초기화를 한번 해준다.
            this.destroyView()
            this.isClipUploadLoading = true
            this.setThumbnailUpload(true)
          }
        }
      },
    },
  },
}
</script>

<style scoped>
#container .v-speed-dial {
  z-index: 999;
  margin-right: 80px;
  margin-bottom: 4px;
  animation-name: horizontal-shaking;
  animation-duration: 1.5s;
  animation-delay: 2s;
  animation-iteration-count: 3;
}

#container .v-speed-dial:hover {
  animation: none;
}

#container .v-btn--floating {
  position: relative;
}
.upload-title {
  display: inline-block;
  color: white;
  font-size: 14px;
  font-weight: 599;
}
.upload-sub-title {
  display: inline-block;
  color: #96a7af;
  font-size: 12px;
}
.container-card-progress {
  border-radius: 10px;
}
.container-progress {
  width: 100%;
  margin: 0;
  background: rgba(16, 16, 16, 0.5);
}
.progress-dialog {
  z-index: 999999 !important;
}
.v-dialog__content {
  z-index: 999999 !important;
}
.container-retry {
  text-align: right;
  margin-top: 16px;
}
.container-retry >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
@keyframes horizontal-shaking {
  0% {
    transform: translateX(0);
  }
  5% {
    transform: translateX(5px);
  }
  10% {
    transform: translateX(-5px);
  }
  15% {
    transform: translateX(5px);
  }
  20% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
